import { Row } from "react-bootstrap";
import UserMetrics from "./UserMetrics";
import TransactionMetrics from "./TransactionMetrics";
import SchoolPaymentMetrics from "./SchoolPaymentsMetrics";
import StatsCards from "./StatsCards";
import "../../styles/dashboard.css";

const Dashboard = () => {
	return (
		<>
			<div className="dashboard-page">
				<div className="page-title">
					<h2>Overview</h2>
				</div>

				<StatsCards />

				<div className="mt-3 p-3">
					<Row className="dashboard-row">
						<UserMetrics />
						<TransactionMetrics />
						<SchoolPaymentMetrics />
					</Row>
				</div>
			</div>
		</>
	)
};

export default Dashboard;